import React, { useEffect, useRef } from 'react';
function scrollIntoResults(target) {
    const top = document.getElementById(target);
    if (!top)
        return;
    top.scrollIntoView({
        behavior: "smooth"
    });
}
export const UseSearch = (props) => {
    let icon = "/assets/images/icons/Search.svg";
    if (props.filterColor == "white") {
        icon = "/assets/images/icons/Search-white.svg";
    }
    return (React.createElement("div", null,
        React.createElement("button", { onClick: props.onClick, "aria-label": "Open Search" },
            React.createElement("img", { src: icon, alt: "Open Search" }))));
};
export const SearchForm = (props) => {
    const queryRef = useRef(null);
    function submitQuery(e) {
        e.preventDefault();
        const target = e.target;
        props.updateQuery(target.query.value);
    }
    let icon = "/assets/images/icons/Search.svg";
    let arrowLeft = "/assets/images/icons/arrow-left.svg";
    let arrowRight = "/assets/images/icons/arrow-right.svg";
    if (props.filterColor == "white") {
        arrowLeft = "/assets/images/icons/arrow-left-white.svg";
        arrowRight = "/assets/images/icons/arrow-right-white.svg";
        icon = "/assets/images/icons/Search-white.svg";
    }
    useEffect(() => {
        queryRef.current.focus();
        scrollIntoResults(props.target);
        return () => {
            scrollIntoResults(props.target);
        };
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("button", { onClick: props.closeSearch, className: 'mb-2 flex items-center gap-2', "aria-label": "Close Search" },
                React.createElement("img", { src: arrowLeft, alt: "" }),
                props.backToLabel)),
        React.createElement("form", { onSubmit: submitQuery, className: 'border-2 p-2 px-3 flex items-center gap-2 ' + (props.filterColor === "white" ? "border-white" : "border-black") },
            React.createElement("label", { htmlFor: "query", className: 'opacity-75' },
                React.createElement("img", { src: icon, alt: "Input Query" })),
            React.createElement("input", { type: "text", name: "query", id: "query", defaultValue: props.query, placeholder: 'Search', className: 'bg-transparent', ref: queryRef }),
            React.createElement("button", { type: 'submit' },
                React.createElement("img", { src: arrowRight, alt: "Submit Query" })))));
};
